import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {MantineProvider} from '@mantine/core';
import * as Sentry from '@sentry/react';
import {API} from '~/utils/request';
import {getUrlParam} from '~/utils/common';

import {configureStore as configureEditorStore} from '~/stores/editor/editor.store';
import {configureStore as configurePlayerStore} from '~/stores/player/player.store';
import {initialState as courseInitialEditorState} from '~/stores/editor/reducers/course.reducer';
import {initialState as courseInitialPlayerState} from '~/stores/player/reducers/course.reducer';

import 'semantic-ui-css/semantic.min.css';
import '@mantine/core/styles.css';
import '~/styles/main.scss';
import './index.css';
import {App} from './App';

import {PlayerFontsLoader} from './components/scene/fields/common-text-element-fields';
import {mantineTheme} from './themes/mantine-theme';
const root = document.querySelector('#root');
const courseId = Number.parseInt(root.getAttribute('courseid') || getUrlParam('id'), 10);

if (process.env.NODE_ENV === 'development') {
  console.error = (function () {
    const {error} = console;

    return function (...args) {
      if (args[0] && args[0].match && /^warn(ing)?:/i.test(args[0])) {
        console.warn(...args);
      } else {
        error.apply(console, args);
      }
    };
  })();
} else {
  Sentry.init({
    dsn: 'https://2253f053e1ba4eacb3719bea08791900@o1035034.ingest.sentry.io/6001690',
    integrations: [Sentry.browserTracingIntegration()],
    release: `bitlearning@${process.env.REACT_APP_VERSION}`,
    tracesSampleRate: .4,
  });
}

API.configureRequests({courseId});
const store
  = !process.env.REACT_APP_TYPE && (window.location.href.includes('/editor') || window.location.href.includes('/nano.edit')) || process.env.REACT_APP_TYPE === 'editor'
    ? configureEditorStore({
      course: {
        ...courseInitialEditorState,
        id: courseId,
      },
    })
    : configurePlayerStore({
      course: {
        ...courseInitialPlayerState,
        id: courseId,
      },
    });

ReactDOM.render(
  <MantineProvider theme={mantineTheme}>
    <Provider store={store}>
      <PlayerFontsLoader />
      <App />
    </Provider>
  </MantineProvider>,
  root,
);
